import { useLocation, useNavigationType } from "react-router-dom";

export function useCanGoBack() {
  const location = useLocation();
  const navType = useNavigationType();

   if (location.pathname === "/main") {
      return false;
    }

  // Первый реальный заход
  if (navType === "POP" && location.key === "default") {
    return false;
  }

  return true;
}
